
import { Modal } from "react-bootstrap";
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { setCartJobItems, setCartJourney } from "redux/actions/cartAction";
import { gtmChooseService } from "lib/google-tag-manager";
import { setLayer } from "redux/actions/globalAction";
import { workshopPurchase } from "lib/config";



const TyreComparisonModal = ({ showModal, handleClose, tyreCompare, handleWorkshopSelection }) => {
  const [showQuoteSelect, setShowQuoteSelect] = useState(false);




  return (
    <Modal
      show={showModal}
      onHide={handleClose}
      size="xl"
      centered
    >
      <Modal.Body className="comparison-body">
        <div className="scroll-table-cop">
          <div className="close-action-btn-comparison">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => handleClose()}
            >
              <span aria-hidden="true">
                <i className="fa-solid fa-xmark" />
              </span>
            </button>
          </div>
          <table className="comparison-table">
            <thead>
              <tr>
                <th>
                  <div className="tyree-com-title">
                    {" "}
                    <span>Tyre </span>Comparison
                  </div>
                </th>
                {tyreCompare.map((item, index) => (
                  <th className="tyre-comp-lst" key={index}>
                    <h3>{item.Name}</h3>
                    <div className="pr-tb-lis-cmp">
                      <div className="lis-cmp-img">
                        {item.ImgUrl ? (
                          <img src={item.ImgUrl} alt="Tire" />
                        ) : (
                          <img src="/assets/products/tire.webp" alt="Tire" />
                        )}


                      </div>
                      <div className="price-comp">
                        <strong>Best Price</strong>
                        <h4>AED {item.Cost}</h4>
                        <p>Size: {item.Tyres.map(data => data.Code)}</p>
                      </div>
                    </div>
                  </th>
                ))}
              </tr>

            </thead>

            <tbody>
              <tr>
                <td>Year of Manufacture</td>
                {tyreCompare.map((item, index) => (
                  item.Tyres.map((tyre, idx) => (
                    <td key={idx}>{tyre.YoM}</td>
                  ))
                ))}
              </tr>
              <tr>
                <td>Warranty</td>
                {tyreCompare.map((item, index) => (
                  item.Tyres.map((tyre, idx) => (
                    <td key={idx}>{tyre.Warranty}</td>
                  ))
                ))}

              </tr>
              <tr>
                <td>Fitting Cost</td>
                {tyreCompare.map((item, index) => (
                  item.Tyres.map((tyre, idx) => (
                    <td key={idx}>AED 100</td>
                  ))
                ))}

              </tr>
              <tr className="applicable-comp">
                <td>
                  Applicable for <i className="fa-regular fa-circle-question" />
                </td>
                {tyreCompare.map((item, index) => (
                  item.Tyres.map((tyre, idx) => (
                    <td key={idx}>Front</td>
                  ))
                ))}

              </tr>
              {/* <tr className="applicable-comp">
                <td>
                  Applicable for <i className="fa-regular fa-circle-question" />
                </td>
                <td>
                  Front <i className="fa-regular fa-circle-question" />
                </td>
                <td>
                  Back <i className="fa-regular fa-circle-question" />
                </td>
                <td>
                  Both <i className="fa-regular fa-circle-question" />
                </td>
              </tr> */}
              <tr>
                <td>Pattern</td>
                {tyreCompare.map((item, index) => (
                  item.Tyres.map((tyre, idx) => (
                    <td key={idx}>{tyre.Pattern}</td>
                  ))
                ))}

              </tr>
              <tr>
                <td>Origin</td>
                {tyreCompare.map((item, index) => (
                  item.Tyres.map((tyre, idx) => (
                    <td key={idx}>{tyre.CountryOfOrigin}</td>
                  ))
                ))}
              </tr>
              <tr>
                <td>Off-roading</td>
                {tyreCompare.map((item, index) => (
                  item.Tyres.map((tyre, idx) => (
                    <td key={idx}>{tyre.IsOffRoading ? 'Yes' : 'No'}</td>
                  ))
                ))}
              </tr>
              <tr>
                <td>Sports</td>
                {tyreCompare.map((item, index) => (
                  item.Tyres.map((tyre, idx) => (
                    <td key={idx}>{tyre.IsSport ? 'Yes' : 'No'}</td>
                  ))
                ))}
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td />
                {tyreCompare.map((item, index) => (
                  <td key={index}>
                    <div className="price-pl-rght">
                      <div className="fitting-checkbox">
                        <label className="chk-label">
                          Get Fitting at Home
                          <input type="checkbox" />
                          <span className="check-mark" />
                        </label>
                        <small>AED 100.00 Extra Charge</small>
                      </div>
                    </div>
                    <button
                      onClick={() => {
                        if (showQuoteSelect) {
                          setShowQuoteSelect(false);
                          localStorage.removeItem(
                            "isQuoterequest"
                          );
                          setCartJourney(
                            workshopPurchase
                          );


                        }
                        handleWorkshopSelection(item);
                        handleClose()
                      }}

                      className="srv-act-action" >Select</button>
                  </td>
                ))}
              </tr>
            </tfoot>




          </table>
        </div>
      </Modal.Body>
    </Modal>
  );
};

const mapStateToProps = (state) => {

  return {
    globalData: state.globalData,
    apiData: state.apiData,
    loginData: state.loginData,
    profile: state.profile,
    cart: state.cart,
  };
};


const mapDispatchToProps = (dispatch) => {
  return {
    AddToCompare: (data) => {
      dispatch(AddToCompare(data));
    },
    setCartJourney: (data) => {
      dispatch(setCartJourney(data));
    },
    setLayer: (status) => {
      dispatch(setLayer(status));
    },
    setCartJobItems: (products) => {
      dispatch(setCartJobItems(products));
    },
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(TyreComparisonModal);

